export { default } from './AlternativeProductsTableError'
